"use client"

import { ImageGallery } from "@/components/image-gallery"
import { useLanguage } from "@/contexts/language-context"

export default function GalleryPage() {
  const { t } = useLanguage()

  return (
    <div className="container mx-auto px-4 py-12 md:px-6">
      <div className="flex flex-col space-y-6">
        <div className="flex flex-col space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">{t("galleryTitle")}</h1>
          <p className="text-muted-foreground">{t("galleryDesc")}</p>
        </div>

        <ImageGallery fullGallery={true} />
      </div>
    </div>
  )
}
